//Lightbox
import SimpleLightbox from "simplelightbox";
let lightbox = new SimpleLightbox('.pdw-lightbox a', { /* options */});